// DO NOT EDIT -- generated from fs/services/dx-objects/journeys.proto

import { OrgToOrgDxObjectCopyResponse } from './copy.proto';
import * as accesscontrol from '../../shared/accesscontrol';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';

export namespace JourneysPublic {

  export const GetAllJourneysEndpoint = "/grpc/dx_objects.JourneysPublic/GetAllJourneys";
  /** Gets all journeys */
  export function GetAllJourneys(sender: (req: GetAllJourneysRequest, endpoint: string) => Promise<GetAllJourneysResponse>, req: GetAllJourneysRequest): { promise: () => Promise<GetAllJourneysResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllJourneysEndpoint),
      endpoint: GetAllJourneysEndpoint
    };
  }

  export const GetJourneyEndpoint = "/grpc/dx_objects.JourneysPublic/GetJourney";
  /** Get a specific journey at the current version. */
  export function GetJourney(sender: (req: GetJourneyRequest, endpoint: string) => Promise<GetJourneyResponse>, req: GetJourneyRequest): { promise: () => Promise<GetJourneyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetJourneyEndpoint),
      endpoint: GetJourneyEndpoint
    };
  }

  export const BatchGetJourneysEndpoint = "/grpc/dx_objects.JourneysPublic/BatchGetJourneys";
  /** Get a batch of journeys by ID, at the current version */
  export function BatchGetJourneys(sender: (req: BatchGetJourneyRequest, endpoint: string) => Promise<BatchGetJourneyResponse>, req: BatchGetJourneyRequest): { promise: () => Promise<BatchGetJourneyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetJourneysEndpoint),
      endpoint: BatchGetJourneysEndpoint
    };
  }

  export const SetJourneyEndpoint = "/grpc/dx_objects.JourneysPublic/SetJourney";
  /** Sets a journey */
  export function SetJourney(sender: (req: SetJourneyRequest, endpoint: string) => Promise<SetJourneyResponse>, req: SetJourneyRequest): { promise: () => Promise<SetJourneyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetJourneyEndpoint),
      endpoint: SetJourneyEndpoint
    };
  }

  export const MarkJourneyViewedEndpoint = "/grpc/dx_objects.JourneysPublic/MarkJourneyViewed";
  /** Updates the LastViewed timestamp for a journey */
  export function MarkJourneyViewed(sender: (req: MarkJourneyViewedRequest, endpoint: string) => Promise<{}>, req: MarkJourneyViewedRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, MarkJourneyViewedEndpoint),
      endpoint: MarkJourneyViewedEndpoint
    };
  }

  export const StarJourneyEndpoint = "/grpc/dx_objects.JourneysPublic/StarJourney";
  /** Stars/unstars a journey */
  export function StarJourney(sender: (req: StarJourneyRequest, endpoint: string) => Promise<{}>, req: StarJourneyRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, StarJourneyEndpoint),
      endpoint: StarJourneyEndpoint
    };
  }

  export const ArchiveJourneyEndpoint = "/grpc/dx_objects.JourneysPublic/ArchiveJourney";
  /** Archives/unarchives a journey */
  export function ArchiveJourney(sender: (req: ArchiveJourneyRequest, endpoint: string) => Promise<ArchiveJourneyResponse>, req: ArchiveJourneyRequest): { promise: () => Promise<ArchiveJourneyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveJourneyEndpoint),
      endpoint: ArchiveJourneyEndpoint
    };
  }

  export const BulkArchiveJourneysEndpoint = "/grpc/dx_objects.JourneysPublic/BulkArchiveJourneys";
  export function BulkArchiveJourneys(sender: (req: BulkArchiveJourneysRequest, endpoint: string) => Promise<BulkArchiveJourneysResponse>, req: BulkArchiveJourneysRequest): { promise: () => Promise<BulkArchiveJourneysResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BulkArchiveJourneysEndpoint),
      endpoint: BulkArchiveJourneysEndpoint
    };
  }

  export const CreateUnnamedJourneyEndpoint = "/grpc/dx_objects.JourneysPublic/CreateUnnamedJourney";
  export function CreateUnnamedJourney(sender: (req: CreateUnnamedJourneyRequest, endpoint: string) => Promise<{}>, req: CreateUnnamedJourneyRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, CreateUnnamedJourneyEndpoint),
      endpoint: CreateUnnamedJourneyEndpoint
    };
  }

  export const GetUnnamedJourneyEndpoint = "/grpc/dx_objects.JourneysPublic/GetUnnamedJourney";
  export function GetUnnamedJourney(sender: (req: GetUnnamedJourneyRequest, endpoint: string) => Promise<GetUnnamedJourneyResponse>, req: GetUnnamedJourneyRequest): { promise: () => Promise<GetUnnamedJourneyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetUnnamedJourneyEndpoint),
      endpoint: GetUnnamedJourneyEndpoint
    };
  }

  export const GetJourneysAccessEndpoint = "/grpc/dx_objects.JourneysPublic/GetJourneysAccess";
  export function GetJourneysAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetJourneysAccessEndpoint),
      endpoint: GetJourneysAccessEndpoint
    };
  }
}

/** JourneysAdmin provides administrative operations for journeys that are restricted to Fullstory internal users */
export namespace JourneysAdmin {

  export const CopyJourneysToOrgEndpoint = "/grpc/dx_objects.JourneysAdmin/CopyJourneysToOrg";
  /**
   * CopyJourneysToOrg copies journeys from one org to another
   * Only accessible to Fullstory internal users
   */
  export function CopyJourneysToOrg(sender: (req: CopyJourneysToOrgRequest, endpoint: string) => Promise<OrgToOrgDxObjectCopyResponse>, req: CopyJourneysToOrgRequest): { promise: () => Promise<OrgToOrgDxObjectCopyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CopyJourneysToOrgEndpoint),
      endpoint: CopyJourneysToOrgEndpoint
    };
  }
}

/**
 * JourneyDetail is the seat's view of a saved Journey.
 * It contains the journey  definition, audit metadata,
 * and seat-level settings such as starred, last viewed timestamp, etc.
 */
export interface JourneyDetail {
  journey: search_settings.JourneyMapRecord | null;
  /** Whether the seat in the request has starred the journey */
  starred: boolean;
  /** When the seat in the request last viewed the journey */
  lastViewed: protobuf.timestamp | null;
}

export interface GetAllJourneysRequest {
  orgId: string;
  /** If true, archived journey s will also be returned. */
  includeArchived: boolean;
}

export interface GetJourneyRequest {
  orgId: string;
  journeyId: string;
}

export interface GetJourneyResponse {
  journey: JourneyDetail | null;
}

/** Note: This mostly lines up with the search-settings BatchGetJourneyRequest, except that we don't allow requesting older versions. */
export interface BatchGetJourneyRequest {
  /** required */
  orgId: string;
  /** required */
  journeyIds: string[];
}

/** Note: This mostly lines up with the search-settings BatchGetJourneyResponse, except that we only return the most recent version. */
export interface BatchGetJourneyResponse {
  /**
   * Results are ordered in the order received from the request.
   * Not found journey maps will return a Result with the id supplied in the request, but a nil JourneyMap in the response.
   * Duplicate requested identifiers will result in duplicate results (to provide 1:1 request to result indexing).
   */
  results: BatchGetJourneyResponse.Result[];
}

/** Note: This mostly lines up with the search-settings BatchGetJourneyResponse, except that we only return the most recent version. */
export namespace BatchGetJourneyResponse {
  export interface Result {
    id: string;
    journey: search_settings.JourneyMapRecord | null;
  }
}

export interface SetJourneyRequest {
  orgId: string;
  journey: search_settings.JourneyMap | null;
  visibility: protoauditstore.Visibility;
}

export interface SetJourneyResponse {
  journey: JourneyDetail | null;
}

export interface GetAllJourneysResponse {
  journeys: JourneyDetail[];
}

export interface MarkJourneyViewedRequest {
  orgId: string;
  journeyId: string;
}

export interface StarJourneyRequest {
  orgId: string;
  journeyId: string;
  /** True to star, false to unstar */
  starred: boolean;
}

export interface ArchiveJourneyRequest {
  orgId: string;
  journeyId: string;
  /** True to archive, false to unarchive */
  archived: boolean;
}

export interface ArchiveJourneyResponse {
  journey: JourneyDetail | null;
}

export interface BulkArchiveJourneysRequest {
  orgId: string;
  journeys: ArchiveJourneyRequest[];
}

export interface BulkArchiveJourneysResponse {
  journeys: MaybeJourneyDetail[];
}

export interface MaybeJourneyDetail {
  journeyId: string;
  failed?: boolean;
  journey?: JourneyDetail | null;
}

export namespace MaybeJourneyDetail {
  export enum failed_or_journey {
    failed = 2,
    journey = 3
  }

  export function failed_or_journey_oneof(m: MaybeJourneyDetail): { opt: failed_or_journey.failed, val: boolean } | { opt: failed_or_journey.journey, val: JourneyDetail } | null {
    if (m.failed != null) { return { opt: failed_or_journey.failed, val: m.failed } }
    if (m.journey != null) { return { opt: failed_or_journey.journey, val: m.journey } }
    return null;
  }
}

export interface UnnamedJourney {
  journey: search_settings.JourneyMap | null;
}

export interface CreateUnnamedJourneyRequest {
  hash: string;
  journey: UnnamedJourney | null;
}

export interface GetUnnamedJourneyRequest {
  hash: string;
}

export interface GetUnnamedJourneyResponse {
  hash: string;
  journey: UnnamedJourney | null;
}

/** Request to copy journeys from one org to another */
export interface CopyJourneysToOrgRequest {
  sourceOrgId: string;
  destinationOrgId: string;
  journeyIds: string[];
  /**
   * Mapping of segment IDs from source to destination
   * source_id -> destination_id
   */
  segmentMappings: { [key: string]: string };
}
